import { SVGProps } from "react";

export default function PrivyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "19"}
      height={props.height ? props.height : "24"}
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <g clipPath="url(#clip0_688_11823)">
        <path
          d="M9.29723 18.5946C14.4312 18.5946 18.5945 14.4312 18.5945 9.29728C18.5945 4.16332 14.4312 0 9.29723 0C4.16327 0 -5.34058e-05 4.16332 -5.34058e-05 9.29728C-5.34058e-05 14.4312 4.16327 18.5946 9.29723 18.5946Z"
          fill="white"
        />
        <path
          d="M9.29722 24C12.806 24 15.651 23.4012 15.651 22.6667C15.651 21.9322 12.8079 21.3335 9.29722 21.3335C5.78657 21.3335 2.94346 21.9322 2.94346 22.6667C2.94346 23.4012 5.78657 24 9.29722 24Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_688_11823">
          <rect width="18.5946" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
